(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nx-card"] && !Shopify.designMode) return;
  try {
    (() => {
  function loadSecondary(link) {
    const template = link?.querySelector('template[data-nx-card-secondary]');
    const image = template?.content.querySelector('img')?.cloneNode(true);
    if (!image) return;
    link.setAttribute('data-nx-secondary-pending', '');
    image.decoding = 'async';
    const ready = () => {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (image.isConnected) link.removeAttribute('data-nx-secondary-pending');
      }));
    };
    const failed = () => {
      image.remove();
      link.removeAttribute('data-nx-secondary-pending');
    };
    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', failed, { once: true });
    template.replaceWith(image);
  }
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    loadSecondary(event.target.closest('.nx-card__image'));
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.nx-card__image');
    if (link?.matches(':focus-visible')) loadSecondary(link);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cart-discount-script"] && !Shopify.designMode) return;
  try {
    (() => {
  /* C4.19: busy per field id, not per element; the bag can render the field anew while a check runs. */
  const busy = new Set();
  const fieldId = root => root?.querySelector('[data-nx-discount-input]')?.id || root?.id || 'nx-discount';
  /* The field that is on the page now: the same element, or the freshly rendered one with the same id. */
  const liveRoot = root => {
    if (!root || root.isConnected) return root;
    const input = document.getElementById(fieldId(root));
    return input?.closest('[data-nx-discount]') || root;
  };
  const codesOf = root => (root.dataset.codes || '').split(',').map(code => code.trim()).filter(Boolean);
  const sameCode = (a, b) => a.toLowerCase() === b.toLowerCase();
  const isGiftCode = code => /^bogos-/i.test(code);
  /* The codes the cart holds right now, the gift app's code included (/cart.js discount_codes); null when it cannot be read. */
  const liveEntries = async () => {
    try {
      const response = await fetch('/cart.js', {cache:'no-store', headers:{Accept:'application/json'}});
      const cart = await response.json();
      if (response.ok && cart && Array.isArray(cart.discount_codes)) return cart.discount_codes.map(item => ({code:String(item.code || '').trim(), applicable:!!item.applicable})).filter(item => item.code);
    } catch (_) {}
    return null;
  };
  const liveCodes = async root => {
    const entries = await liveEntries();
    return entries ? entries.map(item => item.code) : codesOf(root);
  };
  /* Liquid cannot see shipping codes in the cart (not in cart.discount_applications), so every applicable code the cart holds but the markup lacks gets its line and remove control here. */
  const sync = async () => {
    const roots = [...document.querySelectorAll('[data-nx-discount]')];
    if (!roots.length) return;
    const entries = await liveEntries();
    if (!entries) return;
    for (const root of roots) {
      if (!root.isConnected) continue;
      const shown = [...root.querySelectorAll('.nx-discount__code')].map(el => el.textContent.trim());
      root.querySelectorAll('[data-nx-synced]').forEach(el => { if (!entries.some(item => item.applicable && sameCode(item.code, el.dataset.nxSynced))) el.remove(); });
      const row = root.querySelector('.nx-discount__row');
      for (const item of entries) {
        if (!item.applicable || isGiftCode(item.code) || shown.some(code => sameCode(code, item.code))) continue;
        const line = document.createElement('p');
        line.className = 'nx-discount__applied';
        line.dataset.nxSynced = item.code;
        const code = document.createElement('span'); code.className = 'nx-discount__code'; code.textContent = item.code;
        const button = document.createElement('button'); button.className = 'nx-discount__remove'; button.type = 'button'; button.dataset.nxDiscountRemove = item.code; button.textContent = root.dataset.remove || 'Remove'; button.setAttribute('aria-label', (root.dataset.remove || 'Remove') + ' — ' + item.code);
        line.append(code, button);
        if (row) root.insertBefore(line, row); else root.prepend(line);
      }
    }
  };
  let syncTimer = 0;
  const syncSoon = delay => { clearTimeout(syncTimer); syncTimer = setTimeout(sync, delay); };
  const update = async discount => {
    const response = await fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({discount})});
    const cart = await response.json().catch(() => null);
    if (!response.ok || !cart || !Array.isArray(cart.discount_codes)) throw new Error('Cart update failed');
    return cart;
  };
  const say = (root, text, state) => {
    const message = liveRoot(root)?.querySelector('[data-nx-discount-message]');
    if (!message) return;
    message.textContent = text || '';
    message.dataset.state = state || '';
    message.hidden = !text;
  };
  /* The field as it is now, with the typed code put back and the apply button set busy or free again (a fresh render comes empty and enabled). */
  const settle = (root, code, working) => {
    const now = liveRoot(root);
    const input = now?.querySelector('[data-nx-discount-input]');
    const button = now?.querySelector('[data-nx-discount-apply]');
    if (input && code !== undefined && input.value.trim() !== code) input.value = code;
    if (button) button.disabled = working;
    return now;
  };
  /* The bag re-renders through nx-core; it waits while a control inside it keeps focus, so focus is released first. The cart page section renders itself again. */
  const refresh = (root, text) => {
    if (document.activeElement && document.activeElement !== document.body) document.activeElement.blur();
    document.dispatchEvent(new CustomEvent('nx:cart-updated'));
    if (root.closest('#nx-bag-dialog')) return;
    const section = root.closest('.shopify-section');
    if (!section?.id) return;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', section.id.replace(/^shopify-section-/, ''));
    fetch(url.toString(), {cache:'no-store'})
      .then(response => { if (!response.ok) throw new Error(); return response.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.getElementById(section.id) || doc.body;
        section.replaceChildren(...incoming.childNodes);
        say(section.querySelector('[data-nx-discount]'), text, 'done');
        syncSoon(50);
      })
      .catch(() => window.location.reload());
  };
  const apply = async root => {
    const input = root.querySelector('[data-nx-discount-input]');
    const code = (input?.value || '').trim();
    if (!input || !code) { input?.focus(); return; }
    const id = fieldId(root);
    if (busy.has(id)) return;
    busy.add(id);
    input.removeAttribute('aria-invalid');
    settle(root, code, true);
    say(root, root.dataset.checking, 'busy');
    try {
      const existing = (await liveCodes(root)).filter(known => !sameCode(known, code));
      let cart = await update([...existing, code].join(','));
      let entry = cart.discount_codes.find(item => sameCode(item.code, code));
      if (!entry?.applicable && existing.some(isGiftCode)) {
        /* Shopify did not accept the code next to the gift code: try without it. A valid but exclusive code then stands alone and the gift guard takes the gift off and explains; a code that still fails is invalid and the cart goes back to how it was. */
        cart = await update([...existing.filter(known => !isGiftCode(known)), code].join(','));
        entry = cart.discount_codes.find(item => sameCode(item.code, code));
      }
      if (!entry?.applicable) {
        await update(existing.join(','));
        const now = settle(root, code, true);
        const field = now.querySelector('[data-nx-discount-input]');
        field?.setAttribute('aria-invalid', 'true');
        say(now, now.dataset.invalid, 'error');
        field?.focus({preventScroll:true});
        return;
      }
      const now = settle(root, '', true);
      const text = (now.dataset.applied || '').replace('{code}', entry.code);
      say(now, text, 'done');
      refresh(now, text);
    } catch (_) {
      const now = settle(root, code, true);
      say(now, now.dataset.failed, 'error');
    } finally {
      busy.delete(id);
      settle(root, undefined, false);
    }
  };
  const remove = async (root, code) => {
    const id = fieldId(root);
    if (!code || busy.has(id)) return;
    busy.add(id);
    say(root, root.dataset.checking, 'busy');
    try {
      await update((await liveCodes(root)).filter(known => !sameCode(known, code)).join(','));
      const now = liveRoot(root);
      const text = (now.dataset.removed || '').replace('{code}', code);
      say(now, text, 'done');
      refresh(now, text);
    } catch (_) {
      const now = liveRoot(root);
      say(now, now.dataset.failed, 'error');
    } finally {
      busy.delete(id);
    }
  };
  document.addEventListener('click', event => {
    const applyButton = event.target.closest?.('[data-nx-discount-apply]');
    if (applyButton) { event.preventDefault(); apply(applyButton.closest('[data-nx-discount]')); return; }
    const removeButton = event.target.closest?.('[data-nx-discount-remove]');
    if (removeButton) { event.preventDefault(); remove(removeButton.closest('[data-nx-discount]'), removeButton.dataset.nxDiscountRemove); }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches?.('[data-nx-discount-input]')) { event.preventDefault(); apply(event.target.closest('[data-nx-discount]')); }
  });
  document.addEventListener('nx:cart-state', event => { if (!event.detail?.pending) syncSoon(150); });
  document.addEventListener('nx:cart-updated', () => syncSoon(1500));
  window.addEventListener('pageshow', () => syncSoon(300));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => syncSoon(300)); else syncSoon(300);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-cookie-preferences"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-cookie-preferences')) {
  customElements.define('nx-cookie-preferences', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.button || !this.status || this.onClick) return;
      this.onClick = () => this.openPreferences();
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button && this.onClick) this.button.removeEventListener('click', this.onClick);
      this.onClick = null;
      if (this.observer) this.observer.disconnect();
    }

    visible(element) {
      if (!element || !element.isConnected || element.hidden || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true';
    }

    async waitFor(check, deadline) {
      while (this.isConnected && Date.now() < deadline) {
        const result = check();
        if (result) return result;
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      throw new Error('Cookie preferences unavailable');
    }

    async openPreferences() {
      if (this.opening) return;
      this.opening = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.button.setAttribute('aria-busy', 'true');
      this.status.classList.add('nx-screen-reader');
      this.status.hidden = false;
      this.status.textContent = this.button.dataset.loading;
      const deadline = Date.now() + 5000;
      try {
        const banner = await this.waitFor(() => typeof window.privacyBanner?.showPreferences === 'function' && window.privacyBanner, deadline);
        let failure = null;
        Promise.resolve(banner.showPreferences()).catch(error => { failure = error || new Error('Cookie preferences unavailable'); });
        const preferences = await this.waitFor(() => {
          if (failure) throw failure;
          const element = document.getElementById('shopify-pc__prefs');
          return this.visible(element) && element;
        }, deadline);
        this.status.hidden = true;
        if (this.observer) this.observer.disconnect();
        this.observer = new MutationObserver(() => {
          if (this.visible(preferences)) return;
          this.observer.disconnect();
          if (this.isConnected) this.button.focus({ preventScroll: true });
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class', 'aria-hidden'] });
      } catch (_) {
        if (this.isConnected) {
          this.status.classList.remove('nx-screen-reader');
          this.status.hidden = false;
          this.status.textContent = this.button.dataset.error;
        }
      } finally {
        this.opening = false;
        this.button.removeAttribute('aria-disabled');
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-core"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeAdds = new WeakSet();
  const activeQuantities = new WeakSet();
  const initializeQuantities = root => {
    if (!window.fetch) return;
    root.querySelectorAll('[data-nx-quantity-form]').forEach(form => {
      form.dataset.nxQuantityReady = 'true';
      const input = form.querySelector('[data-nx-quantity-input]');
      if (!input) return;
      const value = Number(input.value);
      form.querySelectorAll('[data-nx-quantity-step]').forEach(button => {
        button.disabled = Number(button.dataset.nxQuantityStep) < 0 ? value <= Number(input.min || 1) : !!input.max && value >= Number(input.max);
      });
    });
  };
  const initialize = root => {
    initializeQuantities(root);
    if (!reduceMotion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('nx-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      root.querySelectorAll('[data-nx-reveal]:not(.nx-reveal-ready)').forEach(el => {
        if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('nx-reveal-ready'); observer.observe(el); }
      });
    }

  };
  let headerFrame = 0;
  let headerScrolled = null;
  let header = document.querySelector('.nx-header');
  let hero = document.querySelector('.nx-hero');
  const replayHero = () => {
    if (!hero || reduceMotion.matches) return;
    hero.classList.add('nx-motion-reset');
    requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.remove('nx-motion-reset')));
  };
  const updateHeader = () => {
    headerFrame = 0;
    const scrollY = window.scrollY;
    const scrolled = scrollY > 70;
    if (headerScrolled !== scrolled) {
      headerScrolled = scrolled;
      header?.classList.toggle('nx-scrolled', scrolled);
    }
  };
  const queueHeader = () => { if (!headerFrame) headerFrame = requestAnimationFrame(updateHeader); };
  const refreshHeader = () => {
    header = document.querySelector('.nx-header');
    hero = document.querySelector('.nx-hero');
    headerScrolled = null;
    queueHeader();
  };
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      refreshHeader(); replayHero();
      document.querySelectorAll('form[data-nx-add][data-nx-submitting]').forEach(resetAddForm);
      requestCartRefresh();
    }
  });
  window.addEventListener('scroll', queueHeader, {passive:true});
  window.addEventListener('resize', queueHeader, {passive:true});
  document.addEventListener('shopify:section:load', refreshHeader);
  updateHeader();
  const giftPopupVisible = () => !!document.querySelector('#freegifts-main-popup-container.sca-modal-fg.sca-is-visible-fg');
  const closingDialogs = new Map();
  const clearDialogMotion = dialog => {
    const state = closingDialogs.get(dialog);
    if (!state) return;
    closingDialogs.delete(dialog);
    clearTimeout(state.timer);
    state.animation?.cancel();
    dialog.classList.remove('nx-dialog-closing');
  };
  const closeDialog = dialog => {
    if (!dialog?.open || closingDialogs.has(dialog)) return;
    if (!dialog.matches('.nx-dialog') || reduceMotion.matches || typeof dialog.animate !== 'function') { dialog.close(); return; }
    const state = {};
    const finish = () => {
      if (closingDialogs.get(dialog) !== state) return;
      if (dialog.open) dialog.close();
      clearDialogMotion(dialog);
    };
    closingDialogs.set(dialog, state);
    const style = getComputedStyle(dialog);
    const from = {transform:style.transform, opacity:style.opacity};
    dialog.classList.add('nx-dialog-closing');
    try {
      state.animation = dialog.animate([from, {transform:'translateX(100%)', opacity:.85}], {duration:280, easing:'cubic-bezier(.4,0,.6,1)', fill:'forwards'});
      state.animation.finished.then(finish, finish);
      state.timer = setTimeout(finish, 380);
    } catch (_) { finish(); }
  };
  document.addEventListener('close', event => { if (!event.target.open) clearDialogMotion(event.target); }, true);
  document.addEventListener('cancel', event => {
    if (!event.defaultPrevented && event.target.matches('.nx-dialog')) { event.preventDefault(); closeDialog(event.target); }
  }, true);
  document.addEventListener('shopify:section:unload', event => {
    for (const dialog of closingDialogs.keys()) if (event.target.contains(dialog)) { dialog.close(); clearDialogMotion(dialog); }
  });
  reduceMotion.addEventListener('change', () => {
    if (reduceMotion.matches) for (const dialog of closingDialogs.keys()) { dialog.close(); clearDialogMotion(dialog); }
  });
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open || (dialog.id === 'nx-bag-dialog' && giftPopupVisible())) return;
    clearDialogMotion(dialog);
    dialog.addEventListener('close', () => {
      const restoreFocus = remaining => {
        if (dialog.open || !trigger?.isConnected || (dialog.id === 'nx-bag-dialog' && giftPopupVisible())) return;
        const active = document.activeElement;
        if (active && active !== document.body && active !== document.documentElement && active !== trigger && !dialog.contains(active)) return;
        if (!trigger.disabled && !trigger.closest('[inert]')) trigger.focus({preventScroll:true});
        if (document.activeElement !== trigger && remaining > 0) requestAnimationFrame(() => restoreFocus(remaining - 1));
      };
      requestAnimationFrame(() => requestAnimationFrame(() => restoreFocus(2)));
    }, {once:true});
    dialog.showModal();
    if (dialog.id === 'nx-bag-dialog') {
      dialog.scrollTop = 0;
      const content = dialog.querySelector('.nx-dialog__content');
      if (content) {
        content.scrollTop = 0;
        const scrollArea = content.querySelector('.nx-bag-scroll');
        if (scrollArea) scrollArea.scrollTop = 0;
      }
    }
  };
  let interactionRevision = 0;
  const noteInteraction = () => { interactionRevision += 1; };
  /* Claude C4.12: a touch that only scrolls no longer counts as moving on, so the bag still opens after an add on phones. Clicks and keys still count. */
  document.addEventListener('keydown', noteInteraction, true);
  document.addEventListener('click', noteInteraction, true);
  let cartRevision = 0;
  let cartRefreshFrame = 0;
  let cartRefreshRunning = false;
  let cartRefreshNeeded = false;
  let cartRefreshFailed = false;
  let activeAddCount = 0;
  let pendingCart = null;
  const updateCartRefreshStatus = () => {
    const shippingState = {revision:cartRevision, pending:cartRefreshNeeded || cartRefreshRunning || activeAddCount > 0 || !!pendingCart, failed:cartRefreshFailed};
    document.documentElement.dataset.nxCartRevision = String(shippingState.revision);
    document.documentElement.dataset.nxCartPending = String(shippingState.pending);
    document.documentElement.dataset.nxCartFailed = String(shippingState.failed);
    document.dispatchEvent(new CustomEvent('nx:cart-state', {detail:shippingState}));
    const bag = document.getElementById('nx-bag-dialog');
    const body = bag?.querySelector('.nx-dialog__content');
    if (!body) return;
    const busy = cartRefreshNeeded || cartRefreshRunning || activeAddCount > 0 || !!pendingCart;
    body.setAttribute('aria-busy', String(busy));
    let status = bag.querySelector('.nx-cart-refresh');
    if (!status && (busy || cartRefreshFailed)) {
      const template = document.querySelector('template[data-nx-cart-refresh]');
      status = template?.content.querySelector('.nx-cart-refresh')?.cloneNode(true);
      if (status) body.before(status);
    }
    if (!status) return;
    const statusFocused = status.contains(document.activeElement);
    const visible = cartRefreshFailed || statusFocused;
    status.dataset.state = visible ? 'notice' : 'quiet';
    status.hidden = !busy && !visible;
    const link = status.querySelector('a[href]');
    if (link) link.hidden = !visible;
    const message = status.querySelector('[data-nx-cart-refresh-message]');
    const text = message && (busy ? message.dataset.refreshing : cartRefreshFailed ? message.dataset.failed : '');
    if (message && message.textContent !== text) message.textContent = text;
  };
  const parseCart = html => {
    if (typeof html !== 'string') throw new Error('Cart section unavailable');
    const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('#nx-bag-dialog');
    if (!incoming?.querySelector('.nx-dialog__content') || !incoming.querySelector('#nx-bag-title') || !/^\d+$/.test(incoming.dataset.count || '')) throw new Error('Cart section unavailable');
    return incoming;
  };
  const cartSectionsPath = cartPath => {
    const url = new URL(cartPath, window.location.href);
    return '/' + url.pathname.replace(/^\/+/, '') + url.search;
  };
  const cartRequest = (url, options, readBody) => new Promise((resolve, reject) => {
    const controller = new AbortController();
    let settled = false;
    const finish = (callback, value) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      callback(value);
    };
    const timer = setTimeout(() => {
      finish(reject, new Error());
      controller.abort();
    }, 15000);
    (async () => {
      const response = await fetch(url, {...options, signal:controller.signal});
      if (settled) return;
      const result = await readBody(response);
      finish(resolve, {response, result});
    })().catch(error => finish(reject, error));
  });
  const readCart = async cartPath => {
    const url = new URL(cartPath, window.location.href);
    url.searchParams.set('section_id', 'nx-bag');
    const {result} = await cartRequest(url.toString(), {cache:'no-store'}, response => {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.text();
    });
    return parseCart(result);
  };
  const quantityFocusControl = (form, origin) => {
    if (origin?.matches('[data-nx-quantity-step]')) {
      const buttons = [...form.querySelectorAll('[data-nx-quantity-step]')];
      return buttons.find(button => button.dataset.nxQuantityStep === origin.dataset.nxQuantityStep && !button.disabled) ||
        buttons.find(button => !button.disabled) || document.getElementById('nx-bag-dialog')?.querySelector('[data-nx-close]');
    }
    return form.querySelector('[data-nx-quantity-input]');
  };
  const matchingCartControl = (active, incomingBody) => {
    const quantityForm = active.closest('[data-nx-quantity-form]');
    if (quantityForm) {
      const input = quantityForm.querySelector('[data-nx-quantity-input]');
      if (!activeQuantities.has(quantityForm) && input?.value !== quantityForm.dataset.currentQuantity) return null;
      const nextForm = [...incomingBody.querySelectorAll('[data-nx-quantity-form]')].find(form => form.dataset.lineKey === quantityForm.dataset.lineKey);
      if (!nextForm) return null;
      return quantityFocusControl(nextForm, active);
    }
    const candidates = [...incomingBody.querySelectorAll('a[href], button[name]')].filter(candidate => {
      if (candidate.tagName !== active.tagName || candidate.disabled || candidate.closest('[hidden], [inert]')) return false;
      if (active.tagName === 'A') return candidate.getAttribute('href') === active.getAttribute('href');
      return ['name', 'type', 'value', 'formaction'].every(name => candidate.getAttribute(name) === active.getAttribute(name)) &&
        ['action', 'method'].every(name => candidate.form?.getAttribute(name) === active.form?.getAttribute(name));
    });
    return candidates.length === 1 ? candidates[0] : null;
  };
  const applyCart = (incoming, revision) => {
    if (revision !== cartRevision) return;
    const current = document.getElementById('nx-bag-dialog');
    const currentBody = current?.querySelector('.nx-dialog__content');
    const incomingBody = incoming.querySelector('.nx-dialog__content');
    const title = current?.querySelector('#nx-bag-title');
    if (!currentBody || !title) throw new Error('Cart dialog unavailable');
    cartRefreshFailed = false;
    const active = document.activeElement;
    let replacement = null;
    if (current.open && currentBody.contains(active)) {
      replacement = active.matches('a[href], button[name], [data-nx-quantity-input], [data-nx-quantity-step]') ? matchingCartControl(active, incomingBody) : null;
      if (!replacement) { pendingCart = {incoming, revision}; updateCartRefreshStatus(); return; }
    }
    const scrollArea = currentBody.querySelector('.nx-bag-scroll') || currentBody;
    const incomingScrollArea = incomingBody.querySelector('.nx-bag-scroll') || incomingBody;
    const scrollTop = scrollArea.scrollTop;
    const dialogScrollTop = current.scrollTop;
    currentBody.replaceWith(incomingBody);
    initializeQuantities(incomingBody);
    incomingScrollArea.scrollTop = scrollTop;
    title.textContent = incoming.querySelector('#nx-bag-title').textContent;
    current.dataset.count = incoming.dataset.count;
    current.dataset.nxSampleOnly = incoming.dataset.nxSampleOnly;
    document.querySelectorAll('.nx-cart-count').forEach(count => {
      count.textContent = incoming.dataset.count;
      count.hidden = Number(incoming.dataset.count) <= 0;
    });
    pendingCart = null;
    updateCartRefreshStatus();
    if (replacement) replacement.focus({preventScroll:true});
    current.scrollTop = dialogScrollTop;
  };
  const applyPendingCart = () => {
    if (!pendingCart || activeAddCount) return;
    const pending = pendingCart;
    if (pending.revision !== cartRevision) { pendingCart = null; updateCartRefreshStatus(); return; }
    try { applyCart(pending.incoming, pending.revision); } catch (_) { pendingCart = null; updateCartRefreshStatus(); }
  };
  const queueCartRefresh = () => {
    if (cartRefreshFrame || cartRefreshRunning || activeAddCount || !cartRefreshNeeded) return;
    cartRefreshFrame = requestAnimationFrame(async () => {
      cartRefreshFrame = 0;
      if (activeAddCount || !cartRefreshNeeded) return;
      const cartPath = document.querySelector('a[data-nx-open="nx-bag-dialog"][href]')?.getAttribute('href') || document.querySelector('form[data-nx-add]')?.dataset.cartUrl;
      if (!cartPath) { cartRefreshNeeded = false; updateCartRefreshStatus(); return; }
      cartRefreshRunning = true;
      cartRefreshNeeded = false;
      const revision = cartRevision;
      try {
        const incoming = await readCart(cartPath);
        if (revision === cartRevision && !activeAddCount) applyCart(incoming, revision);
      } catch (_) {
        if (revision === cartRevision && !activeAddCount) cartRefreshFailed = true;
      } finally {
        cartRefreshRunning = false;
        updateCartRefreshStatus();
        queueCartRefresh();
      }
    });
  };
  const requestCartRefresh = () => {
    cartRevision += 1;
    pendingCart = null;
    cartRefreshNeeded = true;
    updateCartRefreshStatus();
    queueCartRefresh();
  };
  const refreshCartOnOpen = () => {
    if (cartRefreshRunning || cartRefreshNeeded || activeAddCount) return;
    requestCartRefresh();
  };
  let cartReturnArmed = document.hidden;
  const armCartReturn = () => { cartReturnArmed = true; noteInteraction(); };
  const refreshReturnedCart = () => {
    if (document.hidden || !cartReturnArmed) return;
    cartReturnArmed = false;
    requestCartRefresh();
  };
  window.addEventListener('blur', armCartReturn);
  window.addEventListener('focus', refreshReturnedCart);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) armCartReturn(); else refreshReturnedCart();
  });
  document.addEventListener('fg-gifts:updated', requestCartRefresh);
  document.addEventListener('bogos:items-added', requestCartRefresh);
  document.addEventListener('nx:cart-updated', requestCartRefresh);
  document.addEventListener('fg-gifts:show-slider', () => {
    const bag = document.getElementById('nx-bag-dialog');
    if (giftPopupVisible() && bag?.open) bag.close();
  });
  document.addEventListener('focusout', event => {
    if (pendingCart) requestAnimationFrame(applyPendingCart);
    if (event.target.closest?.('.nx-cart-refresh')) requestAnimationFrame(updateCartRefreshStatus);
  });
  document.addEventListener('close', event => { if (event.target.id === 'nx-bag-dialog') applyPendingCart(); }, true);
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-nx-open]');
    if (open) {
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (typeof e.button === 'number' && e.button !== 0)) return;
      const dialog = document.getElementById(open.dataset.nxOpen);
      if (!dialog || typeof dialog.showModal !== 'function' || (open.tagName === 'SUMMARY' && open.closest('.nx-menu-fallback')?.open)) return;
      if (open.dataset.nxOpen === 'nx-bag-dialog' && cartRefreshFailed && open.matches('a[href]')) return;
      e.preventDefault();
      if (open.dataset.nxOpen === 'nx-bag-dialog') refreshCartOnOpen();
      openDialog(dialog, open); return;
    }
    const close = e.target.closest('[data-nx-close]');
    if (close) closeDialog(close.closest('dialog'));
    if (e.target.matches('dialog.nx-dialog')) {
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(e.target);
    }

  });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-nx-variant]')) {
      const option = e.target.selectedOptions[0];
      const product = e.target.closest('.nx-product');
      if (!option || !product) return;
      const quantity = product.querySelector('input[name="quantity"]');
      if (quantity) {
        const positiveInteger = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? Number(value) : 1;
        const min = positiveInteger(option.dataset.quantityMin);
        const step = positiveInteger(option.dataset.quantityIncrement);
        const rawMax = Number(option.dataset.quantityMax);
        const max = option.dataset.quantityMax && Number.isSafeInteger(rawMax) && rawMax >= min ? rawMax : null;
        const current = Number(quantity.value);
        let next = Number.isSafeInteger(current) ? Math.max(min, current) : min;
        if (max !== null) next = Math.min(next, max);
        next = min + Math.floor((next - min) / step) * step;
        quantity.min = String(min);
        quantity.step = String(step);
        if (max === null) quantity.removeAttribute('max'); else quantity.max = String(max);
        quantity.value = String(next);
      }
      const price = product.querySelector('[data-nx-price]');
      if (price) price.textContent = option.dataset.price;
      const compare = product.querySelector('[data-nx-compare]');
      if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
      const add = product.querySelector('[name=add]');
      if (add) {
        const form = add.closest('form[data-nx-add]');
        const uncertain = form?.dataset.nxAddUncertain === 'true';
        const available = option.dataset.available === 'true';
        if (form) {
          form.dataset.nxVariantAvailable = String(available);
          syncPurchaseAvailability(form);
          if (!activeAdds.has(form) && !uncertain) { const error = form.querySelector('[data-nx-error]'); if (error) error.textContent = ''; }
        }
        const submitting = activeAdds.has(form) || form?.dataset.nxSubmitting === 'true';
        add.disabled = !uncertain && (!available || submitting);
        const label = add.querySelector('[data-nx-add-label]');
        const adding = document.querySelector('template[data-nx-add-recovery]')?.dataset.adding;
        if (label) label.textContent = uncertain ? form.dataset.nxCheckCartLabel : submitting && adding ? adding : available ? add.dataset.addLabel : add.dataset.soldLabel;
      }
      const url = new URL(window.location.href); url.searchParams.set('variant', e.target.value); history.replaceState({}, '', url);
    }
  });
  const selectedAddVariant = form => form.querySelector('[data-nx-variant]')?.selectedOptions?.[0] || form.querySelector('input[name="id"]');
  const addRejectionMessage = (form, result) => {
    const detail = [result?.errors, result?.description].find(value => value && typeof value === 'object');
    if (detail) {
      const recipient = form.querySelector('[data-nx-recipient]');
      const named = Object.keys(detail).map(key => {
        const field = recipient?.querySelector(`[data-nx-field="${key}"]`);
        field?.setAttribute('aria-invalid', 'true');
        return field?.dataset.nxFieldLabel;
      }).filter(Boolean);
      if (recipient?.dataset.nxErrorPrefix) return named.length ? `${recipient.dataset.nxErrorPrefix} ${named.join(', ')}.` : form.dataset.error;
      const text = Object.values(detail).flat().filter(value => typeof value === 'string').join(' ');
      if (text) return text;
    }
    return (typeof result?.description === 'string' && result.description) || result?.message || form.dataset.error;
  };
  const addVariantAvailable = form => {
    const value = selectedAddVariant(form)?.dataset.available ?? form.dataset.nxVariantAvailable;
    return value !== 'false';
  };
  function syncPurchaseAvailability(form) {
    const available = addVariantAvailable(form);
    const product = form.closest('[data-pdp-root]');
    if (!product) return;
    const options = [...form.querySelectorAll('[data-nx-variant] option')];
    const productAvailable = options.length ? options.some(option => option.dataset.available === 'true') : available;
    product.dataset.pdpAvailable = String(productAvailable);
    const quantity = form.querySelector('input[name="quantity"]:not([type="hidden"])');
    if (quantity) quantity.disabled = !available;
    const express = form.querySelector('.nx-product-express');
    if (express) express.hidden = !available;
    product.querySelector('nx-product-gift')?.toggleAttribute('data-product-unavailable', !available);
    const notice = product.querySelector('[data-pdp-unavailable]');
    if (notice) notice.hidden = available;
    const variantNotice = product.querySelector('[data-pdp-variant-unavailable]');
    if (variantNotice) variantNotice.hidden = !productAvailable;
    const productNotice = product.querySelector('[data-pdp-product-unavailable]');
    if (productNotice) productNotice.hidden = productAvailable;
  }
  async function refreshAddAvailability(form) {
    if (!form.dataset.productUrl) return;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    try {
      const url = new URL(form.dataset.productUrl, window.location.href);
      if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      url.search = ''; url.hash = '';
      const response = await fetch(url.toString(), {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}, signal:controller.signal});
      const missing = response.status === 404;
      if (!response.ok && !missing) return;
      const product = missing ? null : await response.json();
      if (!missing && !Array.isArray(product?.variants)) return;
      const sourceVariants = product?.variants || [];
      if (sourceVariants.some(variant => !variant.id || typeof variant.available !== 'boolean')) return;
      const completeVariantList = sourceVariants.length < 250;
      const variants = new Map(sourceVariants.map(variant => [String(variant.id), variant.available]));
      const button = form.querySelector('[name="add"]');
      for (const field of form.querySelectorAll('[data-nx-variant] option, input[name="id"]')) {
        if (!missing && !completeVariantList && !variants.has(field.value)) continue;
        const available = !missing && variants.get(field.value) === true;
        field.dataset.available = String(available);
        if (field.tagName === 'OPTION') {
          field.disabled = missing || !variants.has(field.value);
          const suffix = ' — ' + (button?.dataset.soldLabel || '');
          const title = field.textContent.endsWith(suffix) ? field.textContent.slice(0, -suffix.length) : field.textContent;
          field.textContent = title + (available ? '' : suffix);
        }
      }
      syncPurchaseAvailability(form);
    } catch (_) {
    } finally { clearTimeout(timer); }
  }
  function resetAddForm(form) {
    if (activeAdds.has(form)) return;
    const button = form.querySelector('[type=submit]');
    delete form.dataset.nxSubmitting;
    if (!button) return;
    const available = addVariantAvailable(form);
    const uncertain = form.dataset.nxAddUncertain === 'true';
    syncPurchaseAvailability(form);
    button.disabled = !uncertain && !available;
    const label = button.querySelector('[data-nx-add-label]');
    if (label) label.textContent = uncertain ? form.dataset.nxCheckCartLabel : !available ? button.dataset.soldLabel : button.dataset.addLabel || label.textContent;
    if (button.dataset.productTitle && label) button.setAttribute('aria-label', label.textContent + ' — ' + button.dataset.productTitle);
    button.removeAttribute('aria-busy');
  }
  let quantityMutationRunning = false;
  const updateQuantity = async (form, removeLink, trigger) => {
    const bag = document.getElementById('nx-bag-dialog');
    if (!window.fetch || !bag || quantityMutationRunning) return;
    const input = form?.querySelector('[data-nx-quantity-input]');
    if (!removeLink && (!input || !form.reportValidity())) return;
    const quantity = removeLink ? 0 : Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0) return;
    if (!removeLink && quantity === Number(form.dataset.currentQuantity)) return;
    const lineKey = form?.dataset.lineKey || removeLink?.dataset.lineKey;
    const cartPath = document.querySelector('a[data-nx-open="nx-bag-dialog"][href]')?.getAttribute('href');
    if (!lineKey || !cartPath) return;
    const changeUrl = form?.dataset.changeUrl || new URL(removeLink.href, window.location.href).pathname + '.js';
    const errorLabel = form?.dataset.error || document.querySelector('template[data-nx-cart-refresh]')?.content.querySelector('[data-nx-cart-refresh-message]')?.dataset.failed;
    const message = form?.querySelector('[data-nx-quantity-error]');
    const priorFocus = document.activeElement;
    const controls = [...bag.querySelectorAll('[data-nx-quantity-form] button, [data-nx-quantity-input], button[name=checkout]')].map(control => ({control, disabled:control.disabled}));
    quantityMutationRunning = true;
    if (form) activeQuantities.add(form);
    activeAddCount += 1;
    requestCartRefresh();
    const postRevision = cartRevision;
    controls.forEach(({control}) => { control.disabled = true; });
    if (message) { message.dataset.state = 'updating'; message.hidden = false; message.textContent = form.dataset.updatingLabel; }
    if (removeLink) removeLink.setAttribute('aria-disabled', 'true');
    const focusCanMove = () => document.activeElement === priorFocus || document.activeElement === document.body || document.activeElement === trigger;
    const preserveQuantityFocus = incoming => {
      const sameLine = [...incoming.querySelectorAll('[data-nx-quantity-form]')].some(candidate => candidate.dataset.lineKey === lineKey);
      if (bag.open && focusCanMove() && (removeLink || !sameLine)) bag.querySelector('[data-nx-close]')?.focus({preventScroll:true});
    };
    let failure = null;
    try {
      const {response, result} = await cartRequest(changeUrl, {method:'POST', headers:{'Accept':'application/json', 'Content-Type':'application/json'}, body:JSON.stringify({id:lineKey, quantity, sections:['nx-bag'], sections_url:cartSectionsPath(cartPath)})}, response => response.json().catch(() => null));
      if (!response.ok) throw new Error(result?.description || result?.message || errorLabel);
      const bundledIsCurrent = postRevision === cartRevision && activeAddCount === 1;
      cartRevision += 1;
      pendingCart = null;
      let incoming;
      let revision;
      if (bundledIsCurrent) {
        try { incoming = parseCart(result?.sections?.['nx-bag']); revision = cartRevision; } catch (_) {}
      }
      for (let attempt = 0; !incoming && attempt < 3; attempt += 1) {
        revision = cartRevision;
        incoming = await readCart(cartPath);
        if (revision !== cartRevision) incoming = null;
      }
      if (!incoming || revision !== cartRevision) throw new Error(errorLabel);
      preserveQuantityFocus(incoming);
      applyCart(incoming, revision);
      cartRefreshNeeded = false;
    } catch (err) {
      failure = err.message || errorLabel;
      cartRevision += 1;
      const revision = cartRevision;
      try {
        const incoming = await readCart(cartPath);
        if (revision !== cartRevision) throw new Error('Cart changed');
        preserveQuantityFocus(incoming);
        applyCart(incoming, revision);
        cartRefreshNeeded = false;
      } catch (_) {
        if (revision !== cartRevision) cartRefreshNeeded = true;
        else { cartRefreshFailed = true; cartRefreshNeeded = false; }
      }
    } finally {
      controls.forEach(({control, disabled}) => { if (control.isConnected) control.disabled = disabled; });
      if (form) activeQuantities.delete(form);
      if (removeLink?.isConnected) removeLink.removeAttribute('aria-disabled');
      quantityMutationRunning = false;
      activeAddCount -= 1;
      applyPendingCart();
      const nextForm = [...bag.querySelectorAll('[data-nx-quantity-form]')].find(candidate => candidate.dataset.lineKey === lineKey);
      const nextMessage = nextForm?.querySelector('[data-nx-quantity-error]');
      if (nextMessage) { nextMessage.dataset.state = failure ? 'error' : 'success'; nextMessage.hidden = false; nextMessage.textContent = failure || nextForm.dataset.updatedLabel; }
      if (failure && nextForm === form && input) input.value = form.dataset.currentQuantity;
      initializeQuantities(bag);
      updateCartRefreshStatus();
      queueCartRefresh();
      if (bag.open && focusCanMove() && nextForm) quantityFocusControl(nextForm, trigger)?.focus({preventScroll:true});
    }
  };
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-nx-quantity-step]');
    if (step) {
      event.preventDefault();
      if (step.disabled || quantityMutationRunning) return;
      const form = step.closest('[data-nx-quantity-form]');
      const input = form?.querySelector('[data-nx-quantity-input]');
      if (!input) return;
      if (Number(step.dataset.nxQuantityStep) < 0) input.stepDown(); else input.stepUp();
      updateQuantity(form, null, step);
    }
    const remove = event.target.closest('[data-nx-remove]');
    if (remove && window.fetch && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      event.preventDefault();
      updateQuantity(remove.closest('.nx-bag-item')?.querySelector('[data-nx-quantity-form]'), remove, remove);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-nx-quantity-input]')) updateQuantity(event.target.closest('[data-nx-quantity-form]'), null, event.target);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-nx-quantity-form]');
    if (!form || event.defaultPrevented || !window.fetch) return;
    event.preventDefault();
    updateQuantity(form, null, event.submitter);
  });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-nx-add]');
    if (!form || !window.fetch || e.defaultPrevented) return;
    e.preventDefault();
    if (form.dataset.nxAddUncertain === 'true') { window.location.assign(form.dataset.cartUrl); return; }
    const button = form.querySelector('[type=submit]');
    const submitter = e.submitter || button;
    const error = form.querySelector('[data-nx-error]');
    if (!button || button.disabled || !addVariantAvailable(form) || activeAdds.has(form) || form.dataset.nxSubmitting === 'true') return;
    form.dataset.nxVariantAvailable = String(addVariantAvailable(form));
    const addInteraction = interactionRevision;
    activeAdds.add(form);
    activeAddCount += 1;
    requestCartRefresh();
    form.dataset.nxSubmitting = 'true';
    button.disabled = true; button.setAttribute('aria-busy', 'true');
    const addingLabel = document.querySelector('template[data-nx-add-recovery]')?.dataset.adding;
    const addLabel = button.querySelector('[data-nx-add-label]');
    if (addingLabel && addLabel) addLabel.textContent = addingLabel;
    if (error) error.textContent = '';
    let added = false;
    let postStarted = false;
    let addRejected = false;
    let navigating = false;
    const showCartPage = () => { navigating = true; window.location.assign(form.dataset.cartUrl); };
    try {
      const body = new FormData(form);
      body.set('sections', 'nx-bag');
      body.set('sections_url', cartSectionsPath(form.dataset.cartUrl));
      const postRevision = cartRevision;
      postStarted = true;
      const {response, result} = await cartRequest(form.dataset.addUrl, {method:'POST',body,headers:{'Accept':'application/json'}}, response => response.json().catch(() => null));
      if (!response.ok) {
        if (response.status === 0 || response.status === 400 || response.status === 408 || response.status >= 500) throw new Error(form.dataset.error);
        addRejected = true;
        const rejection = addRejectionMessage(form, result);
        if (error) error.textContent = rejection;
        if (response.status === 422 || response.status === 404) await refreshAddAvailability(form);
        throw new Error(rejection);
      }
      added = true;
      form.dispatchEvent(new CustomEvent('nx:added', {bubbles:true}));
      const bundledIsCurrent = postRevision === cartRevision && activeAddCount === 1;
      cartRevision += 1;
      pendingCart = null;
      let incoming;
      let revision;
      if (bundledIsCurrent) {
        try { incoming = parseCart(result?.sections?.['nx-bag']); revision = cartRevision; } catch (_) { /* Reconcile only the section; never repeat the add. */ }
      }
      for (let attempt = 0; !incoming && attempt < 3; attempt += 1) {
        revision = cartRevision;
        incoming = await readCart(form.dataset.cartUrl);
        if (revision === cartRevision) break;
        incoming = null;
      }
      if (!incoming || revision !== cartRevision) { showCartPage(); return; }
      applyCart(incoming, revision);
      cartRefreshNeeded = false;
      const bag = document.getElementById('nx-bag-dialog');
      if (addInteraction === interactionRevision && !document.hidden && ![...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== bag)) openDialog(bag, submitter);
    } catch (err) {
      if (added) showCartPage();
      else if (postStarted && !addRejected) {
        form.dataset.nxAddUncertain = 'true';
        form.setAttribute('novalidate', '');
        const recovery = document.querySelector('template[data-nx-add-recovery]')?.content;
        const link = recovery?.querySelector('a[href]');
        if (error && link) {
          form.dataset.nxCheckCartLabel = link.textContent;
          error.replaceChildren(recovery.cloneNode(true));
        } else showCartPage();
      } else if (error) error.textContent = addRejected ? err.message || form.dataset.error : form.dataset.error;
    } finally {
      activeAdds.delete(form);
      activeAddCount -= 1;
      applyPendingCart();
      updateCartRefreshStatus();
      if (!navigating) {
        resetAddForm(form);
        queueCartRefresh();
      }
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document)); else initialize(document);
  document.addEventListener('shopify:section:load', e => initialize(e.target));
})();

(() => {
  const states = new WeakMap();
  let observer;
  let bag;
  const load = () => {
    const slot = bag?.querySelector('[data-nx-wallet-slot]');
    if (!bag?.open || !slot || states.has(slot) || document.documentElement.dataset.nxCartPending === 'true') return;
    const url = new URL(slot.dataset.url, window.location.href);
    if (url.origin !== window.location.origin) return;
    const controller = new AbortController();
    const state = {controller, failed:false};
    const revision = document.documentElement.dataset.nxCartRevision;
    states.set(slot, state);
    const timer = setTimeout(() => controller.abort(), 15000);
    fetch(url, {credentials:'same-origin', cache:'no-store', signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error(); return response.text(); })
      .then(html => {
        if (!slot.isConnected || revision !== document.documentElement.dataset.nxCartRevision || document.documentElement.dataset.nxCartPending === 'true') { states.delete(slot); return; }
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nx-wallet-content]');
        if (!incoming) return;
        slot.replaceChildren(document.importNode(incoming, true));
        slot.hidden = false;
        window.Shopify?.PaymentButton?.init?.();
      })
      .catch(() => { state.failed = true; })
      .finally(() => { clearTimeout(timer); if (slot.isConnected && !states.has(slot)) load(); });
  };
  const connect = () => {
    const next = document.getElementById('nx-bag-dialog');
    if (next === bag) return;
    observer?.disconnect();
    bag = next;
    if (!bag) return;
    observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes') && bag.open) {
        const slot = bag.querySelector('[data-nx-wallet-slot]');
        if (states.get(slot)?.failed) states.delete(slot);
      }
      load();
    });
    observer.observe(bag, {childList:true, subtree:true, attributes:true, attributeFilter:['open']});
    load();
  };
  document.addEventListener('nx:cart-state', load);
  document.addEventListener('shopify:section:load', connect);
  window.addEventListener('pageshow', connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect); else connect();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  window.addEventListener('pagehide', () => {
    document.querySelectorAll('dialog[open]').forEach(dialog => { try { dialog.close(); } catch (_) {} });
    document.querySelectorAll('details.nx-menu-fallback[open]').forEach(menu => { menu.open = false; });
  });

  const wide = window.matchMedia('(min-width: 761px)');
  const footerGroups = () => document.querySelectorAll('.nx-footer__navigation .nx-footer__group');
  const syncFooter = () => footerGroups().forEach(group => {
    const summary = group.querySelector(':scope > summary');
    if (wide.matches) {
      group.open = true;
      summary?.setAttribute('tabindex', '-1');
    } else if (summary?.getAttribute('tabindex') === '-1') {
      summary.removeAttribute('tabindex');
      group.open = false;
    }
  });
  document.addEventListener('toggle', event => {
    if (wide.matches && event.target.matches?.('.nx-footer__navigation .nx-footer__group') && !event.target.open) event.target.open = true;
  }, true);
  wide.addEventListener('change', syncFooter);
  document.addEventListener('shopify:section:load', syncFooter);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFooter); else syncFooter();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-gift-bridge"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('nx-gift-bridge');
  if (!config) return;
  let settings;
  try { settings = JSON.parse(config.textContent); } catch (_) { return; }
  const POPUP_ID = 'freegifts-main-popup-container';
  const VISIBLE = 'sca-is-visible-fg';
  const ARM_MS = 20000;
  const onCartPage = settings.cartPage === true;
  const labels = settings.labels && typeof settings.labels === 'object' ? settings.labels : null;
  let allowUntil = 0;
  let lastArm = 0;
  let shown = false;
  let reopenBag = false;
  let bagOpenAtSlider = 0;
  let hideTimer = 0;
  let localizeFrame = 0;
  let popup = null;
  let classObserver = null;
  let textObserver = null;

  const now = () => Date.now();
  const bag = () => document.getElementById('nx-bag-dialog');
  const allowed = () => onCartPage || now() <= allowUntil;
  const giftSlider = () => window.fgData?.appearance?.gift_slider || window.FGSECOMAPP?.fgAppearance?.gift_slider;
  const allowEverywhere = () => {
    const slider = giftSlider();
    if (!slider) return;
    const display = slider.pages_display && typeof slider.pages_display === 'object' ? slider.pages_display : {};
    const pages = Array.isArray(display.pages) ? display.pages : [];
    if (!pages.includes('all')) slider.pages_display = {...display, pages:[...pages, 'all']};
  };
  const arm = () => {
    if (onCartPage) return;
    lastArm = now();
    allowUntil = lastArm + ARM_MS;
    allowEverywhere();
  };
  const giftsLeft = () => {
    const offers = window.FGSECOMAPP?.offers;
    if (!Array.isArray(offers)) return 0;
    return offers.reduce((sum, offer) => sum + (offer?.isReachConditions && !offer?.is_offer_shipping ? Math.max(0, Number(offer.giftsAvailable) || 0) : 0), 0);
  };
  const syncSlots = () => {
    const open = giftsLeft() > 0;
    document.querySelectorAll('[data-nx-gift-slot]').forEach(slot => { if (slot.hidden === open) slot.hidden = !open; });
  };
  const openBag = () => {
    const dialog = bag();
    const link = document.querySelector('a[data-nx-open="nx-bag-dialog"]');
    if (dialog && !dialog.open && link) link.click();
  };
  const choiceReady = () => {
    bind();
    return !!popup && !!popup.querySelector('.bogos-offer-gift-item') && giftsLeft() > 0;
  };
  const openChoice = () => {
    lastArm = now();
    allowUntil = lastArm + ARM_MS;
    const dialog = bag();
    if (dialog?.open) { reopenBag = true; dialog.close(); }
    popup.classList.add(VISIBLE);
  };

  const translate = text => {
    const value = text.data.trim();
    if (!value) return;
    let next = {'Select variants':labels.variant, 'Add to cart':labels.add, 'Out of stock':labels.soldOut}[value];
    let match;
    if (!next && (match = value.match(/^You can add (\d+) gift product\(s\)$/))) next = (match[1] === '1' ? labels.canAddOne : labels.canAddMany).replace('{n}', match[1]);
    else if (!next && (match = value.match(/^You have added (\d+)\/(\d+) gift product\(s\)$/))) next = labels.added.replace('{a}', match[1]).replace('{b}', match[2]);
    if (typeof next === 'string' && next && next !== value) text.data = text.data.replace(value, next);
  };
  const localize = () => {
    localizeFrame = 0;
    if (!labels || !popup?.isConnected) return;
    const title = popup.querySelector('#bogos-gift-popup-title');
    if (title && labels.title && title.textContent.trim() !== labels.title) title.textContent = labels.title;
    const walker = document.createTreeWalker(popup, NodeFilter.SHOW_TEXT);
    const texts = [];
    for (let node = walker.nextNode(); node; node = walker.nextNode()) texts.push(node);
    texts.forEach(translate);
  };
  const queueLocalize = () => { if (!localizeFrame) localizeFrame = requestAnimationFrame(localize); };

  const onClassChange = () => {
    if (!popup) return;
    if (popup.classList.contains(VISIBLE)) {
      clearTimeout(hideTimer);
      hideTimer = 0;
      if (shown) return;
      if (!allowed()) {
        popup.classList.remove(VISIBLE);
        /* The theme closes the bag when the app opens its popup. If that already happened for this refused attempt, bring the bag back. */
        if (bagOpenAtSlider && now() - bagOpenAtSlider < 1500 && !bag()?.open) { bagOpenAtSlider = 0; openBag(); }
        return;
      }
      shown = true;
      localize();
      if (onCartPage) return;
      const dialog = bag();
      if (dialog?.open) { reopenBag = true; dialog.close(); }
      else if (now() - lastArm < ARM_MS) reopenBag = true;
      requestAnimationFrame(() => popup?.querySelector('.bogos-slider-close-btn')?.focus({preventScroll:true}));
      return;
    }
    if (!shown || hideTimer) return;
    hideTimer = setTimeout(() => {
      hideTimer = 0;
      if (!popup || popup.classList.contains(VISIBLE)) return;
      shown = false;
      allowUntil = 0;
      syncSlots();
      if (reopenBag) { reopenBag = false; openBag(); }
    }, 400);
  };
  const bind = () => {
    const next = document.getElementById(POPUP_ID);
    if (!next || next === popup) return;
    classObserver?.disconnect();
    textObserver?.disconnect();
    popup = next;
    shown = false;
    classObserver = new MutationObserver(onClassChange);
    classObserver.observe(popup, {attributes:true, attributeFilter:['class']});
    if (labels) {
      textObserver = new MutationObserver(queueLocalize);
      textObserver.observe(popup, {childList:true, subtree:true, characterData:true});
      queueLocalize();
    }
    onClassChange();
  };
  const refresh = () => { bind(); syncSlots(); };

  /* Runs before the theme's own listener for the same event: a refused popup is closed here, so the bag is never closed for it. */
  window.addEventListener('fg-gifts:show-slider', () => {
    bind();
    if (!popup) return;
    bagOpenAtSlider = bag()?.open ? now() : 0;
    if (!shown && !allowed() && popup.classList.contains(VISIBLE)) popup.classList.remove(VISIBLE);
  }, true);

  document.addEventListener('submit', event => { if (event.target.closest?.('form[data-nx-add], [data-nx-quantity-form]')) arm(); }, true);
  document.addEventListener('change', event => { if (event.target.matches?.('[data-nx-quantity-input]')) arm(); }, true);
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-nx-quantity-step]')) { arm(); return; }
    if (event.target.closest?.(`[data-open="${POPUP_ID}"]`)) { lastArm = now(); allowUntil = lastArm + ARM_MS; return; }
    const launcher = event.target.closest?.('.nx-product-gift #bogos-to-widget-icon-wrap');
    if (launcher) {
      if (event.defaultPrevented || !choiceReady()) return;
      event.preventDefault();
      event.stopPropagation();
      openChoice();
      return;
    }
    const choose = event.target.closest?.('[data-nx-gift-choose]');
    if (choose) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (typeof event.button === 'number' && event.button !== 0)) return;
      if (!choiceReady()) return;
      event.preventDefault();
      openChoice();
      return;
    }
    if (popup?.contains(event.target)) allowUntil = Math.max(allowUntil, now() + ARM_MS);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && popup?.classList.contains(VISIBLE)) popup.querySelector('.bogos-slider-close-btn')?.click();
  });
  ['fg-app:end', 'fg-gifts:show-slider', 'fg-gifts:updated', 'fg-cart:end-process', 'nx:cart-state'].forEach(name => document.addEventListener(name, refresh));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  window.addEventListener('load', refresh);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-gift-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__nxGiftGuard) return;
  const config = () => document.querySelector('[data-nx-gift-guard]');
  if (!config()) return;
  window.__nxGiftGuard = true;
  const cartPath = '/cart.js';
  const changePath = '/cart/change.js';
  let timer = 0;
  let running = false;
  let notice = '';
  let placeTries = 0;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(check, 900); };
  const place = () => {
    if (!notice) return;
    const hosts = [document.querySelector('#nx-bag-dialog .nx-bag-scroll'), document.querySelector('.nx-cart-summary')].filter(Boolean);
    for (const host of hosts) {
      let note = host.querySelector(':scope > .nx-gift-guard-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'nx-gift-guard-note';
        note.setAttribute('role', 'status');
        host.prepend(note);
      }
      note.textContent = notice;
    }
  };
  const refreshCartPage = () => {
    const page = document.querySelector('.nx-cart-page');
    const section = page?.closest('.shopify-section');
    if (!section?.id) return;
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', section.id.replace(/^shopify-section-/, ''));
    fetch(url.toString(), {cache:'no-store'})
      .then(response => { if (!response.ok) throw new Error(); return response.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.getElementById(section.id) || doc.body;
        section.replaceChildren(...incoming.childNodes);
        place();
      })
      .catch(() => window.location.reload());
  };
  const seen = new Map();
  const removed = new Map();
  async function check() {
    if (running) return;
    running = true;
    try {
      const response = await fetch(cartPath, {credentials:'same-origin', headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      const stale = (cart.items || []).filter(item => item.properties && item.properties._bogos_trigger_type === 'gift' && Number(item.final_line_price) > 0);
      if (!stale.length) { seen.clear(); return; }
      const codes = (cart.discount_codes || []).filter(entry => entry && entry.applicable).map(entry => entry.code);
      const foreign = codes.filter(code => !/^bogos-/i.test(code));
      /* A gift that BOGOS has just added is at full price for a moment before its code lands, and a code that came in by link (/discount/CODE) is still in the cart at that moment: with a foreign code the line must stay stale for 1.2 seconds (C4.17, before: at once), without one for 4 seconds, before it goes. */
      const now = Date.now();
      const due = [];
      const patience = foreign.length ? 1200 : 4000;
      for (const line of stale) {
        const first = seen.get(line.key) || now;
        seen.set(line.key, first);
        const tries = removed.get(line.key) || 0;
        if (tries >= 2) continue;
        if (now - first >= patience) due.push(line);
      }
      if (!due.length) { clearTimeout(timer); timer = setTimeout(check, foreign.length ? 1300 : 4500); return; }
      for (const line of due) {
        removed.set(line.key, (removed.get(line.key) || 0) + 1);
        await fetch(changePath, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({id:line.key, quantity:0})});
        seen.delete(line.key);
      }
      const data = config()?.dataset || {};
      notice = foreign.length ? (data.note || '').replace('{code}', foreign.join(', ')) : (data.plain || '');
      placeTries = 6;
      document.dispatchEvent(new CustomEvent('nx:cart-updated'));
      refreshCartPage();
      place();
    } catch (_) {
      /* The bag stays as it is; the next cart change tries again. */
    } finally {
      running = false;
    }
  }
  const watchUrl = url => /\/cart\/(update|change|add|clear)(\.js)?(\?|$)/.test(String(url || ''));
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const promise = nativeFetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (watchUrl(url)) promise.then(schedule, () => {});
    } catch (_) {}
    return promise;
  };
  const nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { if (watchUrl(url)) this.addEventListener('loadend', schedule); } catch (_) {}
    return nativeOpen.apply(this, arguments);
  };
  document.addEventListener('nx:cart-state', event => {
    if (event.detail && event.detail.pending === false && placeTries > 0) { placeTries -= 1; place(); }
  });
  document.addEventListener('fg-gifts:updated', schedule);
  document.addEventListener('bogos:items-added', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-gift-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-gift-localization')) {
  customElements.define('nx-gift-localization', class extends HTMLElement {
    connectedCallback() {
      if (!['de', 'en'].includes(this.dataset.locale) || this.constructor.owner?.isConnected) return;
      try { this.labels = JSON.parse(this.querySelector('script[type="application/json"]').textContent); }
      catch (_) { return; }
      if (Object.values(this.labels).some(value => typeof value !== 'string' || !value)) return;
      this.constructor.owner = this;
      this.rootId = 'bogos-to-widget-iframe';
      this.appObserver = new MutationObserver(() => this.translate());
      this.shellObserver = new MutationObserver(records => {
        if (this.root) {
          if (!this.root.isConnected) { this.discover(); return; }
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node === this.root || node.contains(this.root))
          ))) this.watchAncestors();
          return;
        }
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeType !== 1) continue;
            const root = node.id === this.rootId ? node : node.querySelector('#' + this.rootId);
            if (root) { this.bindRoot(root); return; }
          }
        }
      });
      this.discover();
    }
    discover() {
      this.appObserver.disconnect();
      this.shellObserver.disconnect();
      this.root = null;
      const root = document.getElementById(this.rootId);
      if (root) this.bindRoot(root);
      else this.shellObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    bindRoot(root) {
      this.root = root;
      this.translate();
      this.appObserver.observe(root, {
        childList: true, subtree: true, characterData: true, attributes: true,
        attributeFilter: ['aria-label', 'title', 'alt', 'data-offer-id']
      });
      this.watchAncestors();
    }
    watchAncestors() {
      this.shellObserver.disconnect();
      for (let parent = this.root.parentElement; parent; parent = parent.parentElement) {
        this.shellObserver.observe(parent, { childList: true });
      }
    }
    replaceText(element, original, replacement) {
      if (!element || !replacement) return;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.data.trim() === original) node.data = node.data.replace(original, replacement);
      }
    }
    replaceAttribute(element, attribute, original, replacement) {
      if (element && replacement && element.getAttribute(attribute) === original) element.setAttribute(attribute, replacement);
    }
    translate() {
      if (!this.root?.isConnected) return;
      const labels = this.labels;
      if (this.dataset.locale === 'de') {
        const dialog = this.root.querySelector('#bogos-to-widget-wrap');
        this.replaceAttribute(dialog, 'aria-label', 'A gift from us', labels.title);
        this.replaceText(this.root.querySelector('.bogos-to-widget-title'), 'A gift from us', labels.title);
        this.root.querySelectorAll('.bogos-to-widget-close[data-close]').forEach(close => {
          this.replaceAttribute(close, 'aria-label', 'Close', labels.close);
          this.replaceAttribute(close, 'title', 'Close', labels.close);
        });
      }
      this.root.querySelectorAll('[data-offer-id="' + labels.offerId + '"]').forEach(offer => {
        const title = offer.querySelector('.bogos-to-item-title');
        const description = offer.querySelector('.bogos-to-item-description');
        const originalTitle = labels.sourceTitle;
        const originalBody = labels.sourceBody;
        if (![originalTitle, labels.offerTitle].includes(title?.textContent.trim()) ||
            ![originalBody, labels.offerBody].includes(description?.textContent.trim())) return;
        this.replaceText(title, originalTitle, labels.offerTitle);
        this.replaceAttribute(title, 'title', originalTitle, labels.offerTitle);
        this.replaceAttribute(title, 'aria-label', originalTitle, labels.offerTitle);
        this.replaceText(description, originalBody, labels.offerBody);
        this.replaceAttribute(description, 'title', originalBody, labels.offerBody);
        this.replaceAttribute(description, 'aria-label', originalBody, labels.offerBody);
        if (this.dataset.locale !== 'de') return;
        offer.querySelectorAll('a.bogos-to-thumb-link').forEach(link => {
          this.replaceAttribute(link, 'aria-label', 'View Travel size Anima', labels.viewAnima);
          this.replaceAttribute(link, 'title', 'View Travel size Anima', labels.viewAnima);
          link.querySelectorAll('img').forEach(image => {
            this.replaceAttribute(image, 'alt', 'Travel size Anima', labels.imageAnima);
            this.replaceAttribute(image, 'title', 'Travel size Anima', labels.imageAnima);
          });
        });
        offer.querySelectorAll('.bogos-to-item-redirect-btn').forEach(button => {
          this.replaceText(button, 'Get offer', labels.getOffer);
          this.replaceAttribute(button, 'aria-label', 'Get offer', labels.getOffer);
          this.replaceAttribute(button, 'title', 'Get offer', labels.getOffer);
        });
      });
      // These synchronous translations must not trigger another full widget scan.
      this.appObserver.takeRecords();
    }
    disconnectedCallback() {
      if (this.constructor.owner !== this) return;
      this.appObserver?.disconnect();
      this.shellObserver?.disconnect();
      this.constructor.owner = null;
      queueMicrotask(() => document.querySelector(`nx-gift-localization[data-locale="${this.dataset.locale}"]`)?.connectedCallback());
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-home-deferred-image"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = new Map();
  const near = new Set();
  let hero;
  let released = false;
  let observer;

  function reveal(target) {
    const template = pending.get(target);
    if (!template || !template.isConnected) {
      pending.delete(target);
      near.delete(target);
      observer?.unobserve(target);
      return;
    }
    const content = template.content.cloneNode(true);
    content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
    template.replaceWith(content);
    pending.delete(target);
    near.delete(target);
    observer?.unobserve(target);
  }

  function release() {
    released = true;
    window.removeEventListener('scroll', checkHero);
    hero?.removeEventListener('load', release);
    hero?.removeEventListener('error', release);
    (observer ? near : pending).forEach((value, target) => reveal(target));
  }

  function checkHero() {
    if (released) return;
    const bounds = hero?.getBoundingClientRect();
    if (!hero || hero.complete || !hero.isConnected || bounds.bottom <= 0 || bounds.top >= window.innerHeight) release();
  }

  function scan(root = document) {
    root.querySelectorAll('template[data-nx-home-image]').forEach(template => {
      const target = template.parentElement;
      if (pending.has(target)) return;
      pending.set(target, template);
      if (observer) observer.observe(target);
      else if (released) reveal(target);
    });
    checkHero();
  }

  function start() {
    hero = document.querySelector('.nx-hero__image[fetchpriority="high"]');
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            near.add(entry.target);
            if (released) reveal(entry.target);
          } else near.delete(entry.target);
        });
        checkHero();
      }, { rootMargin: '300px 0px' });
    }
    hero?.addEventListener('load', release, { once: true });
    hero?.addEventListener('error', release, { once: true });
    window.addEventListener('scroll', checkHero, { passive: true });
    scan();
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      pending.forEach((template, target) => {
        if (event.target.contains(target)) {
          observer?.unobserve(target);
          pending.delete(target);
          near.delete(target);
        }
      });
    });
    window.addEventListener('pageshow', () => scan());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', event => {
  if (event.target.id !== 'nx-country') return;
  const label = event.target.form?.querySelector('[data-nx-currency-region]');
  if (label) label.textContent = event.target.selectedOptions[0]?.dataset.region || '';
});
document.addEventListener('submit', event => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.id !== 'nx-localization') return;
  const returnField = form.elements.namedItem('return_to');
  if (!returnField) return;
  const destination = new URL(window.location.href);
  destination.searchParams.delete('country');
  const path = '/' + destination.pathname.replace(/^\/+/, '');
  returnField.value = path + destination.search + destination.hash;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-product-deferred-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-product-deferred-image')) {
  customElements.define('nx-product-deferred-image', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.start());
    }
    start() {
      if (!this.isConnected || this.started) return;
      this.started = true;
      this.template = this.querySelector('template');
      if (!this.template) return;
      this.mobile = matchMedia('(max-width:760px)');
      if (!this.mobile.matches || !('IntersectionObserver' in window)) { this.reveal(false); return; }
      this.poster = (this.closest('[data-pdp-root]') || document).querySelector('[data-essence-poster]');
      this.released = !this.poster || this.poster.complete;
      this.release = () => {
        this.released = true;
        this.stopWaiting();
        if (this.near) this.reveal();
      };
      this.checkPoster = () => {
        const bounds = this.poster?.getBoundingClientRect();
        if (!this.poster?.isConnected || this.poster.complete || bounds.bottom <= 0 || bounds.top >= innerHeight) this.release();
      };
      this.onViewport = () => { if (!this.mobile.matches) this.reveal(false); };
      this.mobile.addEventListener('change', this.onViewport);
      if (!this.released) {
        this.poster.addEventListener('load', this.release, {once:true});
        this.poster.addEventListener('error', this.release, {once:true});
        window.addEventListener('scroll', this.checkPoster, {passive:true});
      }
      this.observer = new IntersectionObserver(entries => {
        this.near = entries.some(entry => entry.isIntersecting);
        if (!this.released) this.checkPoster();
        if (this.near && this.released) this.reveal();
      }, {rootMargin:'400px 0px'});
      this.observer.observe(this.parentElement);
    }
    reveal(eager = true) {
      if (!this.isConnected || !this.template) return;
      const content = this.template.content.cloneNode(true);
      if (eager) content.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      this.cleanup();
      this.replaceWith(content);
    }
    stopWaiting() {
      if (!this.release) return;
      this.poster?.removeEventListener('load', this.release);
      this.poster?.removeEventListener('error', this.release);
      window.removeEventListener('scroll', this.checkPoster);
    }
    cleanup() {
      this.stopWaiting();
      this.observer?.disconnect();
      if (this.onViewport) this.mobile?.removeEventListener('change', this.onViewport);
    }
    disconnectedCallback() {
      this.cleanup();
      this.started = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-product-gift"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nx-product-gift')) {
  customElements.define('nx-product-gift', class extends HTMLElement {
    static get observedAttributes() { return ['data-product-unavailable']; }
    attributeChangedCallback() { this.sync?.(); }
    connectedCallback() {
      this.media = window.matchMedia('(max-width:760px)');
      this.sync = () => {
        this.observer.disconnect();
        if (!this.media.matches || !this.isConnected || this.hasAttribute('data-product-unavailable')) { this.restore(); return; }
        const widget = document.getElementById('bogos-to-widget-icon-wrap');
        if (!widget) {
          this.restore();
          this.observer.observe(document.body, { childList: true, subtree: true });
          return;
        }
        if (widget.parentElement !== this) {
          this.restore();
          this.widget = widget;
          this.origin = { parent: widget.parentNode, next: widget.nextSibling, label: widget.getAttribute('aria-labelledby') };
          this.label = document.createElement('span');
          this.label.id = this.dataset.labelId;
          this.label.className = 'nx-product-gift__label';
          this.label.textContent = this.dataset.label;
          widget.setAttribute('aria-labelledby', this.label.id);
          this.append(widget, this.label);
          this.setAttribute('data-active', '');
        }
        this.watchAncestors();
      };
      this.observer = new MutationObserver(records => {
        if (this.widget?.isConnected && this.widget.parentElement === this) {
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
            node.nodeType === 1 && (node === this || node.contains(this))
          ))) this.watchAncestors();
          return;
        }
        if (this.widget || records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.id === 'bogos-to-widget-icon-wrap' || node.querySelector('#bogos-to-widget-icon-wrap'))
        ))) this.sync();
      });
      this.media.addEventListener('change', this.sync);
      this.sync();
    }
    watchAncestors() {
      this.observer.disconnect();
      for (let parent = this; parent; parent = parent.parentElement) {
        this.observer.observe(parent, { childList: true });
      }
    }
    restore() {
      if (!this.widget) return;
      this.label?.remove();
      if (this.origin.label === null) this.widget.removeAttribute('aria-labelledby');
      else this.widget.setAttribute('aria-labelledby', this.origin.label);
      if (this.widget.parentElement === this) {
        const parent = this.origin.parent?.isConnected ? this.origin.parent : document.body;
        const next = this.origin.next?.parentNode === parent ? this.origin.next : null;
        parent.insertBefore(this.widget, next);
      }
      this.widget = null;
      this.removeAttribute('data-active');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.media?.removeEventListener('change', this.sync);
      this.restore();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-product-unavailable"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.nxRestockReady) { window.nxRestockReady.initialize?.(document); return; }
  if (!window.fetch || !window.AbortController) return;
  const states = new WeakMap();
  const endpoint = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=Wchez4';
  const variantFor = form => {
    const scope = form.closest('.nx-product__purchase, [data-pdp-root]') || document;
    return scope.querySelector('form[data-nx-add] [name="id"]')?.value || form.dataset.variant;
  };
  const show = (form, key, done = false) => {
    const status = form.querySelector('[data-nx-restock-status]');
    status.textContent = status.dataset[key] || '';
    status.hidden = false;
    form.classList.toggle('is-done', done);
  };
  const ready = form => {
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    form.removeAttribute('aria-busy');
    input.disabled = false;
    button.disabled = false;
    button.textContent = button.dataset.label;
  };
  const initialize = root => {
    root.querySelectorAll('[data-nx-restock]').forEach(form => {
      if (states.has(form)) return;
      states.set(form, { variant: variantFor(form), completed: new Set(), request: null });
      ready(form);
      form.hidden = false;
      const fallback = form.closest('[data-pdp-unavailable]')?.querySelector('[data-nx-restock-fallback]');
      if (fallback) fallback.hidden = true;
    });
  };
  const syncVariant = form => {
    const state = states.get(form);
    if (!state) return;
    const variant = variantFor(form);
    if (variant === state.variant) return;
    state.request?.controller.abort();
    state.request = null;
    state.variant = variant;
    form.dataset.variant = variant;
    ready(form);
    form.querySelector('input[type="email"]').removeAttribute('aria-invalid');
    const completed = state.completed.has(variant);
    form.classList.toggle('is-done', completed);
    if (completed) show(form, 'ok', true);
    else {
      const status = form.querySelector('[data-nx-restock-status]');
      status.hidden = true;
      status.textContent = '';
    }
  };
  const saveLanguage = (email, language) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 5000);
    fetch('https://a.klaviyo.com/client/profiles/?company_id=Wchez4', {
      method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify({ data: { type: 'profile', attributes: { email, properties: { Sprache: language } } } })
    }).catch(() => {}).finally(() => clearTimeout(timer));
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest?.('[data-nx-restock]');
    if (!form) return;
    event.preventDefault();
    initialize(document);
    syncVariant(form);
    const state = states.get(form);
    if (!state || state.request || state.completed.has(state.variant)) return;
    const input = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const email = input.value.trim();
    if (!email || !input.checkValidity()) { input.setAttribute('aria-invalid', 'true'); show(form, 'invalid'); input.focus(); return; }
    input.removeAttribute('aria-invalid');
    const variant = state.variant;
    if (!/^\d+$/.test(variant || '')) { show(form, 'error'); return; }
    const request = { controller: new AbortController(), timedOut: false };
    state.request = request;
    const timer = setTimeout(() => { request.timedOut = true; request.controller.abort(); }, 10000);
    button.disabled = true;
    input.disabled = true;
    button.textContent = button.dataset.sendingLabel;
    form.setAttribute('aria-busy', 'true');
    show(form, 'sending');
    try {
      const response = await fetch(endpoint, {
        method: 'POST', signal: request.controller.signal,
        headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: { profile: { data: { type: 'profile', attributes: { email } } }, channels: ['EMAIL'] }, relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variant } } } } })
      });
      if (state.request !== request || !form.isConnected) return;
      if (!response.ok) throw new Error('subscription');
      state.completed.add(variant);
      show(form, 'ok', true);
      input.value = '';
      saveLanguage(email, form.dataset.lang || 'en');
    } catch (_) {
      if (state.request === request && form.isConnected) show(form, request.timedOut ? 'timeout' : 'error');
    } finally {
      clearTimeout(timer);
      if (state.request === request) {
        state.request = null;
        ready(form);
      }
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-nx-variant]')) return;
    event.target.closest('[data-pdp-root]')?.querySelectorAll('[data-nx-restock]').forEach(syncVariant);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  window.nxRestockReady = { initialize };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nx-runtime-loader"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('nx-runtime-loader')) return;
  const scripts = new Map();
  const allowedPath = /^\/(?:cdn\/shop\/t\/\d+|s\/files\/(?:\d+\/)+t\/\d+)\/assets\/nx-(?:product|spin|locator|shipping)-runtime\.js$/;
  class NXRuntimeLoader extends HTMLElement {
    connectedCallback() {
      if (this.dataset.nxRuntimeWaitFor !== 'nx-shipping-estimator') { this.loadRuntime(); return; }
      this.stopWaiting();
      if (customElements.get('nx-shipping-estimator')) return;
      this.cartIntent = false;
      this.onIntent = event => {
        if (!event.target.closest?.('[data-nx-open="nx-bag-dialog"], #nx-bag-dialog, form[data-nx-add]')) return;
        this.cartIntent = true;
        this.prepareShipping();
      };
      ['pointerover', 'pointerdown', 'focusin', 'click', 'submit'].forEach(type => document.addEventListener(type, this.onIntent, { capture: true, passive: true }));
      this.onRestore = () => this.prepareShipping();
      window.addEventListener('pageshow', this.onRestore);
      this.observer = new MutationObserver(records => {
        const inserted = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('nx-shipping-estimator') || node.querySelector('nx-shipping-estimator'))));
        if (inserted || records.some(record => record.type === 'attributes' && record.target.id === 'nx-bag-dialog')) this.prepareShipping();
      });
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
      customElements.whenDefined('nx-shipping-estimator').then(() => this.stopWaiting());
      this.prepareShipping();
    }
    disconnectedCallback() { this.stopWaiting(); }
    stopWaiting() {
      this.observer?.disconnect();
      if (this.onIntent) ['pointerover', 'pointerdown', 'focusin', 'click', 'submit'].forEach(type => document.removeEventListener(type, this.onIntent, true));
      if (this.onRestore) window.removeEventListener('pageshow', this.onRestore);
      this.onIntent = this.onRestore = null;
    }
    prepareShipping() {
      if (!this.isConnected) return;
      const estimators = Array.from(document.querySelectorAll('nx-shipping-estimator'));
      if (!estimators.length) return;
      const immediate = this.cartIntent || estimators.some(estimator => {
        const bag = estimator.closest('#nx-bag-dialog');
        return !bag || bag.open;
      });
      if (immediate) this.loadRuntime();
    }
    loadRuntime() {
      if (!this.isConnected || !this.dataset.nxRuntimeSrc) return;
      let url;
      try { url = new URL(this.dataset.nxRuntimeSrc, document.baseURI); }
      catch (_) { return; }
      const local = url.origin === location.origin;
      const secure = url.protocol === 'https:' || (local && url.protocol === 'http:');
      const trusted = local || ['pernoire.com', 'www.pernoire.com', 'cdn.shopify.com'].includes(url.hostname);
      if (!secure || !trusted || url.username || url.password || !allowedPath.test(url.pathname) || scripts.has(url.href)) return;
      const existing = Array.from(document.scripts).find(script => script.src === url.href && !script.hasAttribute('data-nx-runtime-error') && !script.hasAttribute('data-anelo-load-error'));
      if (existing) {
        scripts.set(url.href, existing);
        existing.addEventListener('error', () => {
          existing.setAttribute('data-nx-runtime-error', '');
          if (scripts.get(url.href) === existing) scripts.delete(url.href);
        }, { once: true });
        return;
      }
      const script = document.createElement('script');
      script.src = url.href;
      script.async = true;
      scripts.set(url.href, script);
      script.addEventListener('error', () => {
        if (scripts.get(url.href) === script) scripts.delete(url.href);
        script.remove();
      }, { once: true });
      document.head.appendChild(script);
    }
  }
  customElements.define('nx-runtime-loader', NXRuntimeLoader);
})();
  } catch(e) { console.error(e); }
})();

})();
